import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Event, Profile } from 'src/app/core';
import { AuthService, EventService } from 'src/app/core/services';

@Component({
  selector: 'app-one-day-licenses',
  templateUrl: './one-day-licenses.component.html',
  styleUrls: ['./one-day-licenses.component.scss'],
})
export class OneDayLicensesComponent implements OnInit {
  user: Profile;
  event: Event;
  logoutRedirectUrl = window.location;
  loggedIn = false;
  loading = true;

  constructor(
    private authService: AuthService,
    private eventService: EventService,
    private route: ActivatedRoute
  ) {}

  ngOnInit(): void {
    this.authService.currentUser$.subscribe((user) => {
      this.user = user;
      this.loggedIn = !!user.profile_id;
    });
    this.getEvent();
  }

  getEvent(): void {
    const eventId = this.route.snapshot.params.eventId;
    if (eventId) {
      this.eventService.getEvent(eventId).subscribe((event) => {
        if (event) {
          this.event = event;
        }
        this.loading = false;
      });
    } else {
      this.loading = false;
    }
  }
}
